<template>
  <div>
    <div class="animates-items">
      <div class="verticallyCenter">
        <span class="label mr16">方向</span>
        <div class="flex1 verticallyCenter directions-box">
          <el-tooltip
            v-for="(item, index) in directions"
            :key="index"
            class="item"
            effect="dark"
            :content="item.variableLabel"
            placement="top-end"
            :open-delay="1000"
          >
            <span
              @click="selectAnimateDirection(item)"
              :class="[
                'directions',
                'icon-portal-direction-' + item.variableName,
                animateDataVal.direction == item.variableName ? 'selected' : ''
              ]"
            ></span>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fadeIn-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    }
  },
  data() {
    return {
      directions: [
        {
          variableName: "left",
          variableLabel: "向左"
        },
        {
          variableName: "right",
          variableLabel: "向右"
        },
        {
          variableName: "up",
          variableLabel: "向下"
        },
        {
          variableName: "down",
          variableLabel: "向上"
        }
      ],
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      },
      activeDirection: ""
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    }
  },
  mounted() {},
  methods: {
    selectAnimateDirection(item) {
      this.$set(this.animateDataVal, "direction", item.variableName)
      let animateClass, animateLeaveClass
      switch (this.animateDataVal.triggerType) {
        case "hover":
          animateClass = `cx_hover__fadeIn_${item.variableName.toLowerCase()}`
          animateLeaveClass = `cx_hover_leave__fadeIn_${item.variableName.toLowerCase()}`
          break
        case "click":
          animateClass = `cx_click__fadeIn_${item.variableName.toLowerCase()}`
          // animateLeaveClass = `cx_click_leave__fadeIn_${item.variableName.toLowerCase()}`
          break
        default:
          animateClass = `cx_animate__fadeIn_${item.variableName.toLowerCase()}`
      }
      this.$set(this.animateDataVal, "animateClass", animateClass)
      if (animateLeaveClass) {
        this.$set(this.animateDataVal, "animateLeaveClass", animateLeaveClass)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.animates-lists-ul {
  padding: 6px;
  box-sizing: border-box;
}
.animates-lists-li {
  padding: 6px 9px;
  height: 36px;
  box-sizing: border-box;
}
.directions-box {
  background-color: #f3f3f3;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
}
.directions {
  flex: 1;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  &.selected,
  &:hover {
    color: var(--themeColor);
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }
}
</style>
